var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"d-flex flex-column"},[_c('router-view'),_c('GlobalSnackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }